import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'payment.apple.pay.pay.with.apple.pay': {
    id: 'payment.apple.pay.pay.with.apple.pay',
    defaultMessage: 'Pay with Apple Pay',
    description: 'The title of an apple pay button',
  },
});

export default messages;
